<template>
  <a-layout class="index animated fadeIn s_bf">
    <a-card :bordered="false">
      <div class="">
        <a-table
          :pagination="false"
          :loading="pageData.loading"
          bordered
          rowKey="behalf_config_id"
          :columns="tableCp.columns"
          :data-source="pageData.data"
          class="tableFixBox"
          :scroll="{ x: 'max-content' }"
        >
          <template v-slot:action="{ record }">
            <a-button
              size="small"
              type="primary"
              v-has:updatePlaySetAgencyPaymentConfig="
                () => {
                  $router.push(
                    '/system/playSet/config/edit?id=' + record.behalf_config_id
                  );
                }
              "
              class="m-r-5"
              >编辑</a-button
            >
          </template>
        </a-table>
        <a-pagination
          :style="{ marginTop: '20px', textAlign: 'right' }"
          show-size-changer
          show-quick-jumper
          :current="pageData.page"
          :page-size="pageData.perPageCount"
          :total="pageData.total"
          @change="pageOnChange"
          @showSizeChange="pageSizeOnChange"
          :show-total="(total) => `总数: ${total} `"
        />
      </div>
    </a-card>
  </a-layout>
</template>
<script>
import { PlusOutlined, InboxOutlined } from "@ant-design/icons-vue";
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { $iscode } from "@/utils/app";
import { getAgencyPaymentConfigList } from "@/api/system";

export default {
  name: "agencyPaymentConfig",
  components: {},
  setup(props, ctx) {
    const $route = inject("$route");
    const $Modal = inject("$Modal");
    const $store = inject("$store");
    let pageDatum = reactive({
      info: $store.state.user.info
    });

    /* 搜索 start */
    const searchCp = reactive({
      data: {
        keyword: ""
      }
    });
    // 搜索提交
    const searchOnSubmit = (e) => {
      resetPageData();
      getPageData(gainParamData());
    };

    // 时间
    const searchTimeCp = reactive({
      time: []
    });
    // 搜索时间修改
    const searchTimeOnChange = () => {
      searchCp.data.s_time = searchTimeCp.time[0];
      searchCp.data.e_time = searchTimeCp.time[1];
      getPageData(gainParamData());
    };

    /* 搜索 end */

    /* 页面数据 start */
    let pageData = reactive({
      loading: false,
      // 当前第几页
      page: 1,
      // 每页数量，默认一页10条
      perPageCount: 10,
      // 总页数
      pageCount: 1,
      // 总条数，跟pageCount二选一就行
      total: 1,
      data: [],
      // 当前选中的
      currentData: {}
    });
    // 表单配置
    const tableCp = reactive({
      columns: [
        {
          title: "代发配置",
          dataIndex: "title",
          key: "title"
        },
        {
          title: "商户号",
          dataIndex: "mch_name",
          key: "mch_name"
        },
        {
          title: "操作",
          dataIndex: "action",
          key: "action",
          slots: { customRender: "action" }
        }
      ]
    });
    // 清空数据
    const emptyPageData = () => {
      pageData.data = [];
    };
    // 重置数据
    const resetPageData = () => {
      emptyPageData();
      pageData.loading = false;
      pageData.lock = false;
      pageData.page = 1;
    };
    // 获取页面数据
    const getPageData = async (paramData = {}) => {
      if (pageData.loading) {
        return;
      }
      pageData.loading = true;
      emptyPageData();
      let result = await getAgencyPaymentConfigList(paramData)
        .then((res) => res.data)
        .catch((error) => error);
      pageData.loading = false;
      if ($iscode(result, true, false)) {
        let respData = result || [];
        let respList = respData.data || [];
        pageData.data = respList || [];
        pageData.total = respData.total || respList.length;
      }
    };
    // 修改当前页
    const pageOnChange = (e) => {
      pageData.page = e;
      getPageData(gainParamData());
    };
    // 修改每页显示多少行
    const pageSizeOnChange = (currentPage, perPageCount) => {
      resetPageData();
      pageData.perPageCount = perPageCount;
      getPageData(gainParamData());
    };

    /* 页面数据 end */
    // 获取getPageData需要的数据
    const gainParamData = () => {
      // 转换搜索数据
      let searchData = {
        ...searchCp.data
      };
      // 转换分页数据
      let paginationData = {
        page: pageData.page,
        limit: pageData.perPageCount
      };
      return {
        ...searchData,
        ...paginationData
      };
    };

    onMounted(() => {
      if ($route.query.page) {
        pageData.page = $route.query.page;
      }
      getPageData(gainParamData());
    });

    return {
      pageDatum,
      // 搜索相关数据和操作
      searchCp,
      searchOnSubmit,
      searchTimeCp,
      searchTimeOnChange,
      // 页面相关数据和操作
      pageData,
      tableCp,
      pageOnChange,
      pageSizeOnChange
    };
  }
};
</script>
